import get from "lodash/get";
import { useRouter } from "next/router";
import PropTypes from "prop-types";
import React, { useContext } from "react";
import slugify from "slugify";

import EditorialTitle from "@/components/EditorialTitle";
import JoinFlowCTA from "@/components/JoinFlowCTA";
import FormattedDescription from "@/components/description/formatted-description";
import CommonButton from "@/components/links/common";
import { LEAD_FLOW_CTA_SOURCE } from "@/components/seo-and-analytics/adobe-data-layer/acdl-data-layer/lead-flow";
import { UserContext } from "@/context/User";
import { getStyleObject } from "@/utils/helpers/module_style_tags";
import withScreenDimensions from "@/utils/helpers/screen_dimensions";

import styles from "./index.module.scss";

const ModuleText = ({
  isDesktop,
  id,
  data,
  borderTop,
  backgroundColor = "black",
}) => {
  let textAlignClasses, textColorVal;
  const { text, textAlign, textColor, marginBottom, button, anchorTag } = data;

  switch (textAlign) {
    case "left":
      textAlignClasses = styles.textLeft;
      break;
    case "right":
      textAlignClasses = styles.textRight;
      break;
    default:
      textAlignClasses = styles.textCenter;
  }

  switch (textColor) {
    case "white":
      textColorVal = "white";
      break;
    case "black":
      textColorVal = "black";
      break;
    case "gray":
      textColorVal = "#CACACA";
      break;
    default:
      textColorVal = "white";
  }

  const value = get(data, "subNavLabel", id);
  const sectionSlug = slugify(value || "").toLowerCase();
  const editorialTitle = get(data, "editorialTitle", null);
  const textStyles = { borderColor: textColorVal, color: textColorVal };
  const { session } = useContext(UserContext);
  const router = useRouter();
  const isBTL = get(data, "nonUiTitle")
    .toLowerCase()
    .includes("break the love");
  const desktopMarginBottom = isDesktop ? getStyleObject({ marginBottom }) : {};

  return (
    <React.Fragment>
      {!isBTL ||
      (isBTL &&
        session?.user?.accountStatus.toLowerCase() !== "cancelled" &&
        (data?.clubInfo?.clubIds.find(
          (val) => val === session?.user?.homeFacilityId
        ) ||
          session?.user?.hasHamptonsAddOnAgreement)) ||
      (isBTL && router?.query?.memberToken) ? (
        <section
          className={`${styles.moduleText} ${styles[backgroundColor]}`}
          data-attr-module-name="module-text"
          data-attr-scroll={anchorTag || sectionSlug}
          id={sectionSlug}
          style={desktopMarginBottom}
        >
          <div className="container">
            <div className="row">
              {editorialTitle && (
                <div className="col-lg-4 col-md-16">
                  <>
                    <EditorialTitle data={editorialTitle} styles={styles} />
                    <br />
                  </>
                </div>
              )}
              <div
                className={`${
                  editorialTitle
                    ? "offset-xl-2 offset-lg-1 offset-md-0 col-lg-10"
                    : "col-lg-16"
                } col-md-16`}
                style={textStyles}
              >
                <div
                  className={`${styles.moduleTextInner} ${textAlignClasses} ${
                    borderTop && styles.moduleTextInnerAddedBorder
                  }`}
                >
                  {text && (
                    <FormattedDescription allowParagraphs richText={text} />
                  )}

                  {button && (
                    <div
                      style={{
                        marginTop: "100px",
                      }}
                    >
                      {button && button.fields && button.fields.isJoinFlow ? (
                        <JoinFlowCTA
                          className={styles.joinFlowCta}
                          eventSource={LEAD_FLOW_CTA_SOURCE.BODY}
                          label={button.fields.text}
                          originalUrl={button.fields.url}
                        />
                      ) : (
                        <CommonButton
                          styles={textStyles}
                          text={button.fields.text}
                          url={button.fields.url}
                        />
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      ) : (
        <div />
      )}
    </React.Fragment>
  );
};

ModuleText.defaultPropTypes = {
  borderTop: false,
  data: {},
};

ModuleText.propTypes = {
  backgroundColor: PropTypes.string,
  borderTop: PropTypes.bool,
  data: PropTypes.object,
  id: PropTypes.string,
  isDesktop: PropTypes.bool,
};

export default withScreenDimensions(ModuleText);
